/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weekly_PlanningInputs */



/**
* | output |
* | --- |
* | "Weekly planning" |
*
* @param {Weekly_PlanningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const weekly_planning = /** @type {((inputs?: Weekly_PlanningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weekly_PlanningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Weekly planning")
	return /** @type {LocalizedString} */ ("Planning hebdomadaire")
});